import { render, staticRenderFns } from "./Users-Billing-History.vue?vue&type=template&id=11b28ff4&scoped=true&"
import script from "./Users-Billing-History.vue?vue&type=script&lang=js&"
export * from "./Users-Billing-History.vue?vue&type=script&lang=js&"
import style0 from "./Users-Billing-History.vue?vue&type=style&index=0&id=11b28ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b28ff4",
  null
  
)

export default component.exports